import InternalNotifications from './InternalNotifications';

export default InternalNotifications;
